import { ReactElement } from 'react';
import { EmptyStateGeneric } from './empty-state-generic.component';
import { EmptyStateRfv } from './empty-state-rfv.component';
import { EmptyStateShell } from './empty-state-shell.component';

interface ProviderSearchEmptyProps {
  reasonForVisit?: string;
}

export const ProviderSearchEmpty = ({
  reasonForVisit,
}: ProviderSearchEmptyProps): ReactElement => {
  return (
    <EmptyStateShell>
      {reasonForVisit ? (
        <EmptyStateRfv reasonForVisit={reasonForVisit} />
      ) : (
        <EmptyStateGeneric />
      )}
    </EmptyStateShell>
  );
};
